<template>
  <div class="paypalBtnFS">
       <!-- 测试啊 -->
      <!-- <input id="nonce" name="payment_method_nonce" type="hidden" /> -->
      <!-- <img style="margin-left: 33%; margin-top: 8%;" id="paypal-button" src="https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/C2/logos-buttons/34_Grey_CheckOut_Pill_Button.png"> -->
      <!-- <div>{{$attrs.aa}}123</div> -->
      <!-- <div class="abcde">7987987987</div>
      <div class="abcde">7987987987</div>
      <div class="abcde">7987987987</div> -->
      <!-- <div style="float: left:width:200px;height:200px"  v-if="data.shows" > 1111</div> -->
      <Popup   closeable  :close-on-click-overlay="false"  
         v-model="data.shows">
        <Loading  type="spinner" color="#1989fa"></Loading>
      </Popup>
  </div>
</template>
<script>

export default {
  data(){
    return {
      data:{
        shows:true,
        nonce:null,
        amount:null,
        currency:'USD'
      },
      props:{
        detail:{
          type:Object,
          value:''
        },
      }
     
    }
  },
  created(){ 
    console.log()
    // const oScript = document.createElement('script');
    // oScript.type = 'text/javascript';
    // oScript.src = 'https://cdn.bootcdn.net/ajax/libs/jquery/3.2.1/jquery.min.js';
    // document.body.appendChild(oScript);
    // const oScript1 = document.createElement('script');
    // oScript1.type = 'text/javascript';
    // oScript1.src = 'https://js.braintreegateway.com/web/3.29.0/js/client.min.js';
    // document.body.appendChild(oScript1);
    const oScript2 = document.createElement('script');
    oScript2.type = 'text/javascript';
    oScript2.src = 'https://js.braintreegateway.com/web/3.29.0/js/hosted-fields.min.js';
    document.body.appendChild(oScript2);
    const oScript3 = document.createElement('script');
    oScript3.type = 'text/javascript';
    oScript3.src = 'https://js.braintreegateway.com/web/3.29.0/js/paypal.js';
    document.body.appendChild(oScript3);
    const oScript4 = document.createElement('script');
    oScript4.type = 'text/javascript';
    oScript4.src = 'https://js.braintreegateway.com/web/3.29.0/js/paypal-checkout.js';
    document.body.appendChild(oScript4);
    const oScript5 = document.createElement('script');
    oScript5.type = 'text/javascript';
    oScript5.src = 'https://js.braintreegateway.com/web/3.29.0/js/three-d-secure.js';
    document.body.appendChild(oScript5);
  },
  watch:{
    'data.nonce':{  
      handler (newName, oldName) {  //  jq 引入导致 data 多了一层   
      // console.log(this)
        console.log('传给父组件',newName,oldName)   // newName  发生变化传给父组件
        if(newName){
          this.$emit('msg', {paypalShow:false,nonceFromTheClient:newName})  //交易流水号
        }
      },
      deep: true,
      immediate: true  
    }


  },
  mounted(){
    let that = this 
    console.log(126,that)
   $(document).ready(function () {
        // $("#shippingID").hide();
        // $("#btnSubimit").click(function () {
        //     $("#payment-form").submit();
        // });  
        $(function () {
        
            var client_token = that.$attrs.detail.client_token
            var amount = that.$attrs.detail.amount
            // var client_token = "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"
            console.log(77,client_token)
            var paypalButton = document.querySelector('#paypal-button');
            var cardButton = document.querySelector('#card-button');

            braintree.client.create({
                authorization: client_token         //身份验证
            }, function (clientErr, clientInstance)
                {  
                    if (clientErr) {                          
                        return;
                    }
                    //PayPal 支付
                    braintree.paypal.create({
                        client: clientInstance      //客户端实例
                    }, function (paypalErr, paypalInstance) {
                        if (paypalErr) {
                            console.error('Error creating PayPal:', paypalErr);
                            return;
                        }else{
                          that.data.shows = false ;  //JS加载成功 ， 关闭加载框
                        }
                        paypalButton.removeAttribute('disabled');
                        paypalButton.addEventListener('click', function (event) {    //支付按钮监听事件
                            
                            console.log(125,that.$attrs.detail)
                            paypalInstance.tokenize({
                                flow: 'checkout',
                                // amount: document.querySelector('#amount').value,
                                // amount: 0.01,
                                amount: amount,
                                currency: 'USD'
                            }, function (tokenizeErr, payload) {                     
                                if (tokenizeErr) {
                                    if (tokenizeErr.type !== 'CUSTOMER') {
                                        console.log('Error tokenizing:', tokenizeErr);
                                    }
                                    return;
                                }
                                console.log('1Paypal Got nonce:', payload);
                                console.log('2Paypal Got nonce:', payload.nonce);
                                that.data.nonce = payload.nonce
                                
                            });
                        }, false);
                });
            });
        });
    });
  },


}

   
</script>
<style >
 .paypalBtnFS .van-overlay{
    z-index: 20090 !important ;
  }
 .paypalBtnFS .van-popup--center{
    z-index: 20100 !important ;
    background: none;
  }
  .paypalBtnFS  .van-icon-cross::before{
   content: '' !important ;
  }
</style>